module.exports = __webpack_public_path__ + "img/ticket_hover_6b0c40c.webp";